import { Button, Divider } from 'antd';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { travelersClass } from '../../../utils/Constants';
import { icons } from '../../../assets/iconsPath';

const OneWayFareCard = React.memo(({ flightData, index, item }) => {

    const navigate = useNavigate();

    const fetchFlightDetailsTripjack = (id) => {
        sessionStorage.setItem("comeFromReview", "true");
        navigate("/flight-review", { state: { itemId: id, vendorType: item?.vendor } });
    };
  
    const fetchFlightDetailsTBO = (id) => {
        sessionStorage.setItem("comeFromReview", "true");
        navigate("/flight-review", { state: { traceId: item?.traceId, ResultIndex: item?.flightId, vendorType: item?.vendor } });
    };

    return (
        <div className={`fare-card ${index === 0 ? 'highlighted' : ''}`}>
            <div className="fare-card-header">
                <div className="d-flex justify-content-between align-items-center">
                    <div className="lh-sm">
                        <p className="fare-type lh-sm text-primary"><small>{flightData?.fareIdentifier}</small></p>
                        <span className="text-dark fs-5 fw-bold lh-sm">₹{flightData?.after_discount_amount?.toLocaleString()}</span>
                        {/* <p className="text-decoration-line-through lh-sm" style={{fontWeight: '600'}}>₹{item?.priceOptions?.[0]?.totalFare?.toLocaleString()} </p> */}
                    </div>
                    {item?.vendor === "TripJack" && <Button onClick={() => fetchFlightDetailsTripjack(flightData?.id)} className="btn btn-primary menu-block outline-none py-1" aria-label="Book Tripjack now">Book Now</Button>}
                    {item?.vendor === "TBO" && < Button onClick={() => fetchFlightDetailsTBO(flightData?.id)} className="btn btn-primary menu-block outline-none py-1" aria-label="Book TBO Now">Book Now</Button>}
                </div>
            </div >

            <Divider className="my-3" />

            <div className="fare-card-body">
                {/* <div className="fare-details">
                    <div className="fare-row mb-1">
                        <span className="fare-label lh-sm">Cabin Class :</span>
                        <span className="fare-value lh-sm">{travelersClass[flightData?.cabinClass]}</span>
                    </div>
                    <div className="fare-row mb-1">
                        <span className="fare-label lh-sm">Base Fare :</span>
                        <span className="fare-value lh-sm">{flightData?.baseFare}</span>
                    </div>
                    <div className="fare-row mb-1">
                        <span className="fare-label lh-sm">Tax Fare :</span>
                        <span className="fare-value lh-sm">{flightData?.taxFare}</span>
                    </div>
                    <div className="fare-row mb-1">
                        <span className="fare-label lh-sm">Check-in baggage :</span>
                        <span className="fare-value lh-sm">{flightData?.baggage}</span>
                    </div>
                    <div className="fare-row mb-1">
                        <span className="fare-label lh-sm">Cabin baggage :</span>
                        <span className="fare-value lh-sm">{flightData.cabinBaggage}</span>
                    </div>

                    {item?.vendor === "TripJack" &&
                        <>
                            <div className="fare-row">
                                <span className="fare-label lh-sm">Meal :</span>
                                <span className="fare-value lh-sm">{flightData?.meal}</span>
                            </div>

                            <div className="fare-row">
                                <span className="fare-label lh-sm">Refund :</span>
                                <span className="fare-value lh-sm">{flightData?.refund_type}</span>
                            </div>
                        </>
                    }

                </div> */}
                <div className="fare-details">
                    <div className="mb-3">
                        <h4 className='d-flex align-items-center gap-2 mb-2'><img src={icons.Baggage} alt='Yes' width={18} /> Baggage</h4>
                        <ul className='ps-4'>
                            <li className='d-flex align-items-center gap-2'>
                                {flightData.cabinBaggage ? (
                                    <>
                                        <img src={icons.Check} alt='Yes' width={14} />
                                        {flightData.cabinBaggage} Cabin Baggage
                                    </>
                                ) : (
                                    <>
                                        <img src={icons.Times} alt='No' width={14} />
                                        No Cabin Baggage
                                    </>
                                )}
                            </li>
                            <li className='d-flex align-items-center gap-2'>
                                {flightData.baggage ? (
                                    <>
                                        <img src={icons.Check} alt='Yes' width={14} />
                                        {flightData.baggage} Check-in Baggage
                                    </>
                                ) : (
                                    <>
                                        <img src={icons.Times} alt='No' width={14} />
                                        No Check-in Baggage
                                    </>
                                )}
                            </li>
                        </ul>
                    </div>
                    <div className="mb-3">
                        <h4 className='d-flex align-items-center gap-2 mb-2'><img src={icons.Calendar} alt='Yes' width={18} /> Flexibility</h4>
                        <ul className='ps-4'>
                            {item?.vendor === "TripJack" &&
                                <>
                                    <li className='d-flex align-items-center gap-2'>
                                        {flightData.refund_type ? (
                                            <>
                                                <img src={icons.Check} alt='Yes' width={14} />
                                                {flightData.refund_type}
                                            </>
                                        ) : (
                                            <>
                                                <img src={icons.Times} alt='No' width={14} />
                                                No refund on Cancellation
                                            </>
                                        )}
                                    </li>
                                </>
                            }
                        </ul>
                    </div>

                    <div className="">
                        <h4 className='d-flex align-items-center gap-2 mb-2'><img src={icons.Meal} alt='Yes' width={18} /> Addons</h4>
                        <ul className='ps-4'>
                            {item?.vendor === "TripJack" &&
                                <>
                                    <li className='d-flex align-items-center gap-2'>
                                        {flightData.meal ? (
                                            <>
                                                <img src={icons.Check} alt='Yes' width={14} />
                                                {flightData?.meal}
                                            </>
                                        ) : (
                                            <>
                                                <img src={icons.Times} alt='No' width={14} />
                                                Meals information not available
                                            </>
                                        )}
                                    </li>
                                </>
                            }
                        </ul>
                    </div>

                    <div className=''>
                        {flightData.coupon_discount && (
                            <>
                                <h5 className='mt-3 bg-light-success px-2 py-2 rounded text-success text-center'>
                                    {flightData.coupon_discount}
                                </h5>
                            </>
                        )}
                    </div>


                </div>
            </div>
        </div >
    );
});

export default OneWayFareCard;

